import { NOTIFICATIONS_CHANNELS_PER_TYPE } from '@sigma-legacy-libs/essentials/lib/schemas/notifications'

import { proxy, services } from '@/utils'

import render from './render'

export default {
  name: 'NotificationPanel',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    path: {
      type: String,
      default: undefined
    },

    loading: Boolean,

    permission: {
      type: [ String, Boolean ],
      default: undefined
    },

    UserId: String,
    ResellerId: String,

    payload: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    availableChannels() {
      let result
      for (const key in NOTIFICATIONS_CHANNELS_PER_TYPE) {
        if (this.path.includes(key)) {
          result = NOTIFICATIONS_CHANNELS_PER_TYPE[key]
          break
        }
      }

      if (Array.isArray(result)) {
        return result
      } else {
        return []
      }
    },

    hasSettings() {
      return Array.isArray(this.value.settings)
    },

    currency() {
      return this.payload.settings?.[`${services.billings}.currency`]
    }
  },

  methods: {
    update(channel) {
      if (this.proxy.channels?.includes(channel)) {
        this.proxy.channels?.splice(this.proxy.channels?.indexOf(channel), 1)
      } else {
        this.proxy.channels?.splice(this.proxy.channels?.length, 0, channel)
      }
      if (this.proxy.channels?.length === 0) {
        this.proxy.enabled = false
      }
    }
  },

  render
}
